module.exports = __webpack_public_path__ + "img/inicioFill.0496d02a.svg";